import DataRequest from './dataRequest';
import URLS from '../constants/urlConstants';
import { IPricingCurrentEndOfDayResponse } from '../types/interfaces';
import { resolvePromiseWithError } from '../utilities/utils';

export const getPricingCurrentEndOfDayStats = async (
	venueXid: number,
): Promise<IPricingCurrentEndOfDayResponse> => {
	if (!venueXid) {
		return await resolvePromiseWithError();
	}
	return await DataRequest.execute(
		`${URLS.PLATFORM.PRICING_CURRENT_END_OF_DAY_STATS}/v1/details/` + venueXid,
	);
};

//OP-1192 - Fetching Pricing End of Day Stats Data
export const getPricingCurrentEndOfDayMultiXidStats = async (
	venueXids: number[],
): Promise<IPricingCurrentEndOfDayResponse> => {
	if (!venueXids || venueXids.length === 0) {
		return await resolvePromiseWithError();
	}
	return await DataRequest.execute(
		`${URLS.PLATFORM.PRICING_CURRENT_END_OF_DAY_STATS}/v1/multiXidStats?venueXidList=` + venueXids.join(',')
	);
};
